module.exports = __webpack_public_path__ + "static/media/TH3AZ [SizeOnly].558f064b.svg";